import { useRenameDocumentMutation } from '@graphql/generated';

export const useRenameDocument = () => {
  const [renameDocumentMutation, { loading }] = useRenameDocumentMutation();

  const renameDocument = async (
    documentId: string,
    name: string,
    onComplete?: (newName: string) => void,
    onError?: (error: Error) => void
  ) => {
    try {
      const result = await renameDocumentMutation({
        variables: { id: documentId, name },
      });

      if (result.data?.renameDocument) {
        onComplete?.(name);
      } else {
        onError?.(new Error('Rename failed'));
      }
    } catch (error) {
      onError?.(error as Error);
    }
  };

  return { renameDocument, loading };
};
